import React from 'react';
import styled from 'styled-components';

import folder from 'assets/windowsIcons/318(48x48).png';
import document from 'assets/windowsIcons/308(16x16).png';

function MyDocuments({ onOpenApp }) {
  function onClickFolder(item) {
    if (item === 'My Pictures' && onOpenApp) {
      onOpenApp('My Pictures');
    }
  }

  return (
    <Div>
      <div className="docs__toolbar">
        <span>File</span>
        <span>Edit</span>
        <span>View</span>
        <span>Favorites</span>
        <span>Tools</span>
        <span>Help</span>
      </div>
      <div className="docs__address">
        <span>Address</span>
        <div className="docs__address-path">
          <img src={document} alt="" />
          My Documents
        </div>
      </div>
      <div className="docs__content">
        {['My Music', 'My Pictures', 'My Videos'].map(item => (
          <button
            key={item}
            type="button"
            className="docs__item"
            onClick={() => onClickFolder(item)}
          >
            <img src={folder} alt="" />
            <span>{item}</span>
          </button>
        ))}
      </div>
    </Div>
  );
}

const Div = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: Tahoma, 'Noto Sans', sans-serif;
  font-size: 11px;
  color: #111;
  background: #ece9d8;
  border-left: 1px solid #0831d9;
  border-right: 1px solid #0831d9;
  border-bottom: 1px solid #0831d9;

  .docs__toolbar {
    height: 23px;
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 0 8px;
    background: #ece9d8;
    border-bottom: 1px solid #d8d2bd;
    flex-shrink: 0;
  }

  .docs__address {
    height: 28px;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 3px 6px;
    color: #6b6b6b;
    background: #ece9d8;
    border-top: 1px solid #fff;
    border-bottom: 1px solid #aca899;
    flex-shrink: 0;
  }

  .docs__address-path {
    height: 20px;
    min-width: 0;
    flex: 1;
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 1px 4px;
    color: #111;
    background: #fff;
    border: 1px solid #7f9db9;
  }

  .docs__address-path img {
    width: 16px;
    height: 16px;
  }

  .docs__content {
    flex: 1;
    display: flex;
    align-content: flex-start;
    gap: 18px 22px;
    flex-wrap: wrap;
    padding: 18px;
    background: #fff;
  }

  .docs__item {
    width: 86px;
    min-height: 76px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    border: 1px solid transparent;
    background: transparent;
    color: #111;
    font-family: inherit;
    font-size: 11px;
  }

  .docs__item:hover {
    border-color: #b5c7e5;
    background: #edf4ff;
  }

  .docs__item img {
    width: 48px;
    height: 48px;
  }
`;

export default MyDocuments;
